import React from "react";
import { useNavigate } from "react-router-dom";
import { useRef } from "react";
import Footer from "../components/Footer/PrelaunchFooter/Footer";
import Navbar from "../components/Navbar/Navbar";

const TermsConditions = () => {
  const navigate = useNavigate();
  const handleRedirect = () => navigate("../RefundPolicy");
  const handlePrivacy = () => navigate("../privacyPolicy");

  const aboutUsRef = useRef(null);
  const ourProcessRef = useRef(null);
  const manufactureRef = useRef(null);
  const ingredientsRef = useRef(null);

  return (
    <div style={styles.pageContainer}>
      <div style={styles.navbar}>
        <Navbar
          aboutUsRef={aboutUsRef}
          ourProcessRef={ourProcessRef}
          manufactureRef={manufactureRef}
          ingredientsRef={ingredientsRef}
        />
      </div>
      <div style={styles.contentContainer}>
        <h1 style={styles.title}>Terms and Conditions</h1>
        <p style={styles.subtitle}>(Effective Date: 01st Feb, 2025)</p>

        <div style={styles.textContainer}>
          <h2 style={styles.sectionTitle}>OVERVIEW</h2>
          <p style={styles.text}>
            This website is operated by <strong>Frissly</strong>. Throughout the
            site, the terms <strong>"we," "us," and "our"</strong> refer to{" "}
            <strong>Frissly</strong>. <strong>Frissly</strong> offers this
            website, including all information, tools, and services available
            from this site to you, the user, conditioned upon your acceptance of
            all terms, conditions, policies, and notices stated here.
          </p>
          <p style={styles.text}>
            By visiting our site and/or purchasing something from us, you engage
            in our <strong>"Service"</strong> and agree to be bound by the
            following{" "}
            <strong>
              Terms and Conditions ("Terms of Service" or "Terms")
            </strong>
            , including any additional terms and policies referenced herein
            and/or available by hyperlink. These{" "}
            <strong>Terms of Service</strong> apply to all users of the site,
            including but not limited to browsers, vendors, customers,
            merchants, and content contributors.
          </p>
          <p style={styles.text}>
            Please read these <strong>Terms of Service</strong> carefully before
            accessing or using our website. By accessing or using any part of
            the site, you agree to be bound by these{" "}
            <strong>Terms of Service</strong>. If you do not agree to all the
            terms and conditions, you may not access the website or use any{" "}
            <strong>services</strong>.
          </p>
          <p style={styles.text}>
            Any new features or tools added to the current store shall also be
            subject to these <strong>Terms of Service</strong>. We reserve the
            right to update, change, or replace any part of these{" "}
            <strong>Terms of Service</strong> by posting updates and/or changes
            to our website. It is your responsibility to check this page
            periodically for changes. Your continued use of or access to the
            website following any changes constitutes acceptance of those
            changes.
          </p>

          <h2 style={styles.sectionTitle}>SECTION 1 - ONLINE STORE TERMS</h2>
          <p style={styles.text}>
            By agreeing to these <strong>Terms of Service</strong>, you
            represent that:
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. You are <strong>at least the age of majority</strong> (18 years
              or older) in your state or province of residence.
            </li>
            <li style={styles.listItem}>
              2. You will not use our <strong>products</strong> for any{" "}
              <strong>illegal or unauthorized purpose</strong>, including
              violating any laws in your jurisdiction.
            </li>
            <li style={styles.listItem}>
              3. You must not transmit any{" "}
              <strong>malicious code, viruses, or destructive elements</strong>{" "}
              to or from our site.
            </li>
            <li style={styles.listItem}>
              4. Any violation of these terms will result in{" "}
              <strong>immediate termination</strong> of our{" "}
              <strong>services</strong>.
            </li>
          </ul>

          <h2 style={styles.sectionTitle}>SECTION 2 - GENERAL CONDITIONS</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. We reserve the right to <strong>refuse service</strong> to
              anyone for any reason at any time.
            </li>
            <li style={styles.listItem}>
              2. Your content (excluding credit card information) may be
              transferred unencrypted over various networks.
            </li>
            <li style={styles.listItem}>
              3.{" "}
              <strong>
                Payments for purchases are processed securely through Razorpay
                and CCAvenue
              </strong>
              , managed via <strong>Juspay</strong>, our third-party payment
              orchestration platform.
            </li>
            <li style={styles.listItem}>
              4.{" "}
              <strong>
                Frissly does not store or process payment details directly
              </strong>
              . Transactions are handled securely by{" "}
              <strong>Razorpay, CCAvenue, and Juspay</strong>, which adhere to{" "}
              <strong>RBI guidelines</strong> and{" "}
              <strong>PCI-DSS compliance</strong>.
            </li>
            <li style={styles.listItem}>
              5. You{" "}
              <strong>
                agree not to reproduce, duplicate, copy, sell, or exploit
              </strong>{" "}
              any portion of the <strong>Service</strong> without our express
              written permission.
            </li>
          </ul>

          <h2 style={styles.sectionTitle}>
            SECTION 3 - PAYMENT PROCESSING & SECURITY
          </h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. <strong>Payment Methods Accepted:</strong> We accept payments
              via{" "}
              <strong>
                Credit Cards, Debit Cards, UPI, Net Banking, and Wallets
              </strong>{" "}
              through <strong>Razorpay</strong> and <strong>CC Avenue</strong>,
              facilitated by <strong>Juspay</strong>.
            </li>
            <li style={styles.listItem}>
              2. <strong>Secure Transactions:</strong>
              <ul style={styles.bulletList}>
                <li style={styles.bulletItem}>
                  Payments are securely processed by{" "}
                  <strong>Razorpay, CCAvenue</strong> and{" "}
                  <strong>Juspay</strong>, which comply with{" "}
                  <strong>RBI regulations</strong> and{" "}
                  <strong>PCI-DSS security standards</strong>.
                </li>
                <li style={styles.bulletItem}>
                  <strong>Juspay acts as an orchestration platform</strong> to
                  facilitate seamless transactions.
                </li>
              </ul>
            </li>
            <li style={styles.listItem}>
              3. <strong>UPI Virtual Payment Address (VPA) Handling:</strong>
              <ul style={styles.bulletList}>
                <li style={styles.bulletItem}>
                  To enhance user convenience,{" "}
                  <strong>we display the Virtual Payment Address (VPA)</strong>{" "}
                  associated with UPI transactions within the app.
                </li>
                <li style={styles.bulletItem}>
                  This allows users to quickly confirm their UPI ID without
                  manually entering it for every transaction.
                </li>
                <li style={styles.bulletItem}>
                  <strong>We do not store, modify, or use the VPA</strong> for
                  any purpose other than displaying it for user ease.
                </li>
              </ul>
            </li>
            <li style={styles.listItem}>
              4. <strong>Authorization & Charges:</strong>
              <ul style={styles.bulletList}>
                <li style={styles.bulletItem}>
                  When you place an order, <strong>Razorpay, CCAvenue</strong>{" "}
                  and <strong>Juspay</strong> may place an{" "}
                  <strong>authorization hold</strong> on your payment method.
                </li>
                <li style={styles.bulletItem}>
                  <strong>Frissly is not responsible</strong> for payment
                  failures, chargebacks, or unauthorized transactions.
                </li>
              </ul>
            </li>
            <li style={styles.listItem}>
              5. <strong>Failed Transactions & Refunds:</strong>
              <ul style={styles.bulletList}>
                <li style={styles.bulletItem}>
                  In case of <strong>failed transactions</strong>, funds may be{" "}
                  <strong>automatically refunded</strong> by{" "}
                  <strong>Razorpay</strong> or <strong>CC Avenue</strong> as per
                  their policies.
                </li>
                <li style={styles.bulletItem}>
                  If a refund is delayed beyond <strong>7 business days</strong>
                  , users must contact <strong>Razorpay</strong>,{" "}
                  <strong>CC Avenue</strong>, or their issuing bank.
                </li>
              </ul>
            </li>
          </ul>
          <p style={styles.text}>
            For refund-related queries, visit our{" "}
            <span style={styles.link} onClick={handleRedirect}>
              Refund Policy
            </span>
          </p>

          <h2 style={styles.sectionTitle}>SECTION 4 - PRODUCTS OR SERVICES</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. Some products or services may be available{" "}
              <strong>exclusively online</strong> through our website.
            </li>
            <li style={styles.listItem}>
              2. These products may have <strong>limited quantities</strong> and
              are subject to return or exchange only as per our{" "}
              <span style={styles.link} onClick={handleRedirect}>
                Refund Policy
              </span>
              .
            </li>
            <li style={styles.listItem}>
              3. All product descriptions and pricing are{" "}
              <strong>subject to change without notice</strong> at our sole
              discretion.
            </li>
          </ul>
          <p style={styles.text}>
            For more details, please review our{" "}
            <span style={styles.link} onClick={handleRedirect}>
              Refund Policy
            </span>
          </p>

          <h2 style={styles.sectionTitle}>
            SECTION 5 - ACCURACY OF BILLING AND ACCOUNT INFORMATION
          </h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. We reserve the right to <strong>refuse any order</strong>{" "}
              placed with us.
            </li>
            <li style={styles.listItem}>
              2. Customers must provide{" "}
              <strong>current, complete, and accurate</strong> billing and
              shipping information.
            </li>
            <li style={styles.listItem}>
              3. If we suspect{" "}
              <strong>fraudulent or unauthorized transactions</strong>, we may
              cancel the order and notify <strong>Razorpay</strong> or{" "}
              <strong>CC Avenue</strong> for further verification.
            </li>
          </ul>
          <p style={styles.text}>
            For more details, please review our{" "}
            <span style={styles.link} onClick={handleRedirect}>
              Refund Policy
            </span>
          </p>

          <h2 style={styles.sectionTitle}>SECTION 6 - THIRD-PARTY LINKS</h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. Certain content, products, or services may{" "}
              <strong>include third-party materials</strong>.
            </li>
            <li style={styles.listItem}>
              2. We are <strong>not responsible</strong> for examining or
              evaluating third-party content, including{" "}
              <strong>Razorpay’s</strong> and <strong>CC Avenue’s</strong>
              policies.
            </li>
            <li style={styles.listItem}>
              3. We are <strong>not liable</strong> for any harm or damages
              related to third-party purchases.
            </li>
          </ul>

          <h2 style={styles.sectionTitle}>
            SECTION 7 - PERSONAL INFORMATION & PRIVACY POLICY
          </h2>
          <p style={styles.text}>
            Your submission of personal information is governed by our{" "}
            <strong>Privacy Policy</strong>, which can be viewed here:{" "}
            <span style={styles.link} onClick={handlePrivacy}>
              Privacy Policy
            </span>
          </p>

          <h2 style={styles.sectionTitle}>
            SECTION 8 - ERRORS, INACCURACIES, AND OMISSIONS
          </h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. Occasionally, there may be information on our site that
              contains{" "}
              <strong>typographical errors, inaccuracies, or omissions</strong>{" "}
              related to product descriptions, pricing, promotions, and
              availability.
            </li>
            <li style={styles.listItem}>
              2. We reserve the right to{" "}
              <strong>
                correct errors, update information, or cancel orders
              </strong>{" "}
              at any time without prior notice.
            </li>
          </ul>

          <h2 style={styles.sectionTitle}>
            SECTION 9 - DISCLAIMER OF WARRANTIES & LIMITATION OF LIABILITY
          </h2>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              1. We <strong>do not guarantee</strong> that your use of our{" "}
              <strong>service</strong> will be uninterrupted or error-free.
            </li>
            <li style={styles.listItem}>
              2. You expressly agree that your use of our{" "}
              <strong>service</strong> is <strong>at your sole risk</strong>.
            </li>
            <li style={styles.listItem}>
              3. <strong>Frissly is not responsible</strong> for payment-related
              disputes; these should be raised directly with{" "}
              <strong>Razorpay, CCAvenue, or your issuing bank</strong>.
            </li>
          </ul>

          <h2 style={styles.sectionTitle}>
            SECTION 10 - GOVERNING LAW & JURISDICTION
          </h2>
          <p style={styles.text}>
            These <strong>Terms of Service</strong> and any agreements whereby
            we provide services shall be{" "}
            <strong>
              governed by and construed in accordance with the laws of India
            </strong>
            .
          </p>
          <p style={styles.text}>
            Any disputes shall be subject to the{" "}
            <strong>
              exclusive jurisdiction of courts in Hyderabad, Telangana, India
            </strong>
            .
          </p>

          <h2 style={styles.sectionTitle}>
            SECTION 11 - CHANGES TO TERMS OF SERVICE
          </h2>
          <p style={styles.text}>
            We <strong>reserve the right</strong> to update, change, or replace
            any part of these <strong>Terms of Service</strong> by posting
            updates on our website.
          </p>
          <p style={styles.text}>
            Your continued use of or access to our <strong>website</strong>{" "}
            constitutes acceptance of those changes.
          </p>

          <h2 style={styles.sectionTitle}>SECTION 12 - CONTACT INFORMATION</h2>
          <p style={styles.text}>
            📧 <strong>Email:</strong>{" "}
            <a href="mailto:support@frissly.com" style={styles.link}>
              support@frissly.com
            </a>
          </p>
          <p style={styles.text}>
            📞 <strong>Phone:</strong> +91-XXXXXXXXXX
          </p>
          <p style={styles.text}>
            📍 <strong>Address:</strong> Frissly HQ, Hyderabad, India
          </p>
          <p style={styles.text}>For payment-related queries:</p>
          <p style={styles.text}>
            <strong>Juspay Support:</strong>
          </p>
          <ul style={styles.list}>
            <li style={styles.listItem}>
              <strong>Email:</strong>{" "}
              <a href="mailto:support@juspay.in" style={styles.link}>
                support@juspay.in
              </a>
            </li>
            <li style={styles.listItem}>
              <strong>Phone:</strong> +91 80-4095-9660
            </li>
            <li style={styles.listItem}>
              <strong>Website:</strong>{" "}
              <a href="https://juspay.io/contact" style={styles.link}>
                https://juspay.io/contact
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

const styles = {
  pageContainer: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
  },
  navbar: {
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  contentContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "20px",
    maxWidth: "800px",
    margin: "0 auto",
  },
  title: {
    fontFamily: "Nunito, sans-serif",
    fontSize: "32px",
    fontWeight: "bold",
    color: "#000000",
    marginBottom: "10px",
    textAlign: "center",
  },
  subtitle: {
    fontFamily: "Nunito, sans-serif",
    fontSize: "18px",
    color: "#555555",
    marginBottom: "20px",
    textAlign: "center",
  },
  textContainer: {
    fontFamily: "Nunito, sans-serif",
    fontSize: "16px",
    lineHeight: "24px",
    color: "#555555",
    textAlign: "left",
    width: "100%",
  },
  sectionTitle: {
    fontFamily: "Nunito, sans-serif",
    fontSize: "18px",
    fontWeight: "bold",
    color: "#000000",
    marginTop: "20px",
    marginBottom: "10px",
  },
  subSectionTitle: {
    fontFamily: "Nunito, sans-serif",
    fontSize: "20px",
    fontWeight: "bold",
    color: "#333333",
    marginTop: "15px",
    marginBottom: "10px",
  },
  list: {
    listStyleType: "disc",
    paddingLeft: "20px",
    marginBottom: "15px",
  },
  divider: {
    borderBottom: "1px solid #cccccc",
    margin: "20px 0",
  },
};

export default TermsConditions;
